var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"3"}}),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{on:{"change":_vm.change},model:{value:(_vm.localAmount),callback:function ($$v) {_vm.localAmount=$$v},expression:"localAmount"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }